import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { exportToExcelAsync, getAllEvents, getAllPickupLocations, getEventPublicAccessInfo, getEventStats, getPaginatedInvitationsByEventId } from './f1Thunk';
const initialState = {
    eventsInfo: [],
    eventStats: null,
    eventId: '',
    eventType: null,
    paginatedInvitations: null,
    status: APIStatus.IDLE,
    pickUpLocations: null,
    paginatedInvitationsToExportInExcel: null,
    publicAccessEventInfo: null,
    filters: {
        invitationId: null,
        invitationStatus: null,
        eventId: '',
        page: 1,
        pageSize: 20,
        isExportMode: false,
        isArchived: false,
        searchParam: null
    }
};
export const f1IntegrationSlice = createSlice({
    name: 'f1Integration',
    initialState,
    reducers: {
        clearEventsInfo: (state) => {
            state.eventsInfo = [];
        },
        clearEventStats: (state) => {
            state.eventStats = null;
        },
        clearPublicAccessEventInfo: (state) => {
            state.publicAccessEventInfo = null;
        },
        setEventId: (state, action) => {
            state.eventId = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        setEventType: (state, action) => {
            state.eventType = action.payload;
        },
        resetFilters: (state) => {
            state.filters = {
                invitationId: null,
                invitationStatus: null,
                eventId: '',
                page: 1,
                pageSize: 20,
                isExportMode: false,
                isArchived: false,
                searchParam: ''
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllEvents.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEvents.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventsInfo = action.payload;
        })
            .addCase(getAllEvents.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //================================================================================
        builder
            .addCase(getEventStats.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventStats.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventStats = action.payload;
        })
            .addCase(getEventStats.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //================================================================================
        builder
            .addCase(getPaginatedInvitationsByEventId.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPaginatedInvitationsByEventId.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedInvitations = action.payload;
        })
            .addCase(getPaginatedInvitationsByEventId.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //================================================================================
        builder
            .addCase(exportToExcelAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(exportToExcelAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedInvitationsToExportInExcel = action.payload;
        })
            .addCase(exportToExcelAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //================================================================================
        builder
            .addCase(getAllPickupLocations.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPickupLocations.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickUpLocations = action.payload;
        })
            .addCase(getAllPickupLocations.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        //================================================================================
        builder
            .addCase(getEventPublicAccessInfo.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventPublicAccessInfo.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickUpLocations = action.payload;
        })
            .addCase(getEventPublicAccessInfo.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearEventsInfo, clearEventStats, setEventId, setEventType, setFilters, resetFilters, clearPublicAccessEventInfo } = f1IntegrationSlice.actions;
export default f1IntegrationSlice.reducer;
